import { createBrowserRouter } from "react-router-dom";
import About from "../About";
import Contact from "../Contact";
import Hero from "../Hero";
import Home from "../Home";
import Main from "../Main";
import Portfolio from "../Portfolio";
import ProjectsDetails from "../ProjectsDetails";
import Skills from "../Skills";

export const router =createBrowserRouter([
{
    path:'/',
    element:<Home></Home>,
    children:[
        {
            path:'/',
            element: <Main />
        },
        
        {
            path:'/services/:id',
            element:<ProjectsDetails></ProjectsDetails>
        }
        
               
                
                

               
    ]
}
])